<template>
  <div class="line_chart" ref="lineChart"></div>
</template>

<script>
const echarts = require('echarts');
export default {
    props:["opts"],
    watch: {
        opts(newObj, oldObj) {
            if (newObj.xAxis_data.length != oldObj.xAxis_data.length){
                this.drawLine(this.opts.xAxis_data,this.opts.series_data);
            }
        }
    },
    methods:{
        drawLine(xAxis_data,series_data){
            let itemChart = echarts.init(this.$refs.lineChart);
            itemChart.setOption({
                tooltip: { trigger: "axis" },
                grid: {
                    left: "0%",
                    right: "30px",
                    top:"20px",
                    bottom: "5%",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: xAxis_data,
                    axisLine: {
                        show:false
                    },
                    splitLine: {
                        show:false
                    },
                    axisTick:{
                        show:false
                    },
                    axisLabel: {
                        color:"#2192ff",
                        interval:(index) => {
                            return index ==0 || index == xAxis_data.length-1
                        }
                    }
                    

                },
                yAxis: {
                    type: "value",
                    show:false,
                    axisLine: {
                        show:false
                    },
                    splitLine:{
                        show:false
                    }
                },
                series: [
                    {
                        name: "销量",
                        type: "line",
                        data: series_data,
                        // smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#df8363"
                            }
                        },
                        // label:{
                        //     show:true,
                        //     formatter:(params) => {
                        //         return params.dataIndex == series_data.length-1?params.dataset:''
                        //     }
                        // }

                    }
                ]
            });
        }
    }
}
</script>

<style scoped>
    .line_chart{
        width: 100%;
        height: 100%;
    }
</style>